import { useState, useEffect } from 'react'
import { getConfig, saveConfig } from '../utils/storage'
import { useAuth } from '../contexts/AuthContext'
import { supabase } from '../utils/supabase'
import { getPrecos, savePrecos } from '../utils/precos'
import { ADICIONAIS_BOOLEAN, ADICIONAIS_QUANTIDADE, PUXADOR_TIPOS } from '../data/adicionais'
import { CATEGORIAS_MODELO } from '../data/modelos'
import { Save, Check, ChevronDown, Plus, Trash2, KeyRound, Link2, Link2Off, RefreshCw, Upload } from 'lucide-react'
// Plus and Trash2 used in price table section
import { getBlingAuthUrl, getStoredTokens, clearBlingTokens, isBlingConnected } from '../utils/bling'
import { pushAllToSupabase } from '../utils/supabase'

export function Config() {
  const { user, profile }       = useAuth()
  const [config, setConfig]       = useState(() => getConfig())
  const [salvo, setSalvo]         = useState(false)
  const [blingTokens, setBlingTokens] = useState(() => getStoredTokens())
  const [syncStatus, setSyncStatus] = useState('')

  async function handlePushToCloud() {
    setSyncStatus('loading')
    try {
      const { count } = await pushAllToSupabase()
      setSyncStatus(`ok:${count}`)
      setTimeout(() => setSyncStatus(''), 5000)
    } catch (e) {
      console.error(e)
      setSyncStatus('error')
      setTimeout(() => setSyncStatus(''), 5000)
    }
  }

  // ── Tabela de preços ──
  const [precos, setPrecos]         = useState(() => getPrecos())
  const [catPrecoAberta, setCatPre] = useState(null)
  const [salvoPrecos, setSalvoPrecos] = useState(false)

  function setPrecoModelo(modelo, valor) {
    setPrecos(prev => ({ ...prev, modelos: { ...prev.modelos, [modelo]: valor } }))
    setSalvoPrecos(false)
  }
  function setMultiModelo(modelo, valor) {
    setPrecos(prev => ({ ...prev, multiplicadores: { ...prev.multiplicadores, [modelo]: valor } }))
    setSalvoPrecos(false)
  }
  function setMultiDefault(valor) {
    setPrecos(prev => ({ ...prev, multiplicadorDefault: valor }))
    setSalvoPrecos(false)
  }
  function setPrecoAdicional(key, valor) {
    setPrecos(prev => ({ ...prev, adicionais: { ...prev.adicionais, [key]: valor } }))
    setSalvoPrecos(false)
  }
  function setPrecoPuxador(tipo, valor) {
    setPrecos(prev => ({ ...prev, puxadores: { ...prev.puxadores, [tipo]: valor } }))
    setSalvoPrecos(false)
  }
  function handleSalvarPrecos() {
    savePrecos(precos)
    setSalvoPrecos(true)
    setTimeout(() => setSalvoPrecos(false), 2500)
  }


  // ── Trocar senha ──
  const [senhaNova, setSenhaNova]       = useState('')
  const [senhaConf, setSenhaConf]       = useState('')
  const [mostrarSenhas, setMostrarSenhas] = useState(false)
  const [erroSenha, setErroSenha]       = useState('')
  const [okSenha, setOkSenha]           = useState('')
  const [loadingSenha, setLoadingSenha] = useState(false)

  async function handleTrocarSenha() {
    if (!senhaNova || !senhaConf)      { setErroSenha('Preencha todos os campos'); return }
    if (senhaNova !== senhaConf)       { setErroSenha('A nova senha e a confirmação não coincidem'); return }
    if (senhaNova.length < 6)          { setErroSenha('A nova senha deve ter pelo menos 6 caracteres'); return }
    setLoadingSenha(true)
    setErroSenha('')
    const { error } = await supabase.auth.updateUser({ password: senhaNova })
    setLoadingSenha(false)
    if (error) { setErroSenha('Erro ao alterar senha. Tente novamente.'); return }
    setSenhaNova(''); setSenhaConf('')
    setOkSenha('Senha alterada com sucesso!')
    setTimeout(() => setOkSenha(''), 3000)
  }

  function set(key, value) {
    setConfig(prev => ({ ...prev, [key]: value }))
    setSalvo(false)
  }

  function handleSalvar() {
    saveConfig(config)
    setSalvo(true)
    setTimeout(() => setSalvo(false), 2500)
  }

  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <div className="mb-6">
        <h1 className="text-xl font-bold text-[#111111]">Configurações</h1>
        <p className="text-sm text-slate-400 mt-1">Dados da empresa e integrações</p>
      </div>

      {/* Dados da empresa */}
      <div className="card p-6 space-y-4 mb-5">
        <h3 className="text-sm font-bold text-[#111111] uppercase tracking-wide">Dados da empresa</h3>
        <div>
          <label className="label">Nome da empresa</label>
          <input value={config.nomeEmpresa || ''} onChange={e => set('nomeEmpresa', e.target.value)}
            className="input" placeholder="MINI Marcenaria" />
        </div>
        <div>
          <label className="label">CNPJ</label>
          <input value={config.cnpj || ''} onChange={e => set('cnpj', e.target.value)}
            className="input" placeholder="00.000.000/0001-00" />
        </div>
        <div className="grid grid-cols-2 gap-3">
          <div>
            <label className="label">Telefone</label>
            <input value={config.telefone || ''} onChange={e => set('telefone', e.target.value)}
              className="input" placeholder="(00) 90000-0000" />
          </div>
          <div>
            <label className="label">E-mail</label>
            <input type="email" value={config.email || ''} onChange={e => set('email', e.target.value)}
              className="input" placeholder="contato@mini.com" />
          </div>
        </div>
        <div>
          <label className="label">Endereço</label>
          <input value={config.endereco || ''} onChange={e => set('endereco', e.target.value)}
            className="input" placeholder="Rua, número, cidade — UF" />
        </div>
      </div>

      {/* Banner de erro de escrita no Supabase — aparece se o último upsert
          falhou. Muitas vezes o valor é salvo no localStorage local mas
          NÃO chega no Supabase (RLS bloqueando, rede caindo etc.). Sem
          esse aviso, vendedora achava que salvou e o valor "voltava" no
          próximo sync porque o Supabase ainda tinha o valor antigo. */}
      <ErroEscritaBanner />

      {/* Tabela de Preços */}
      <div className="card p-6 space-y-5 mb-5">
        <h3 className="text-sm font-bold text-[#111111] uppercase tracking-wide">Tabela de Preços</h3>
        <p className="text-xs text-slate-400 -mt-3">
          Configure o multiplicador da Precificação (FORMINI). Deixe em 0 se não usar.
        </p>

        {/* Multiplicador padrão */}
        <div>
          <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">Multiplicador padrão (Precificação)</p>
          <p className="text-xs text-slate-400 mb-2">Usado quando o modelo não tem multiplicador individual definido.</p>
          <div className="flex items-center gap-3 max-w-xs">
            <input
              type="number" min="1" max="10" step="0.1"
              value={precos.multiplicadorDefault ?? 3.5}
              onChange={e => setMultiDefault(Number(e.target.value) || 3.5)}
              className="input text-sm text-center"
            />
            <span className="text-sm text-slate-500 shrink-0">× (MDF + ferragens)</span>
          </div>
        </div>

        {/* Ajuste rápido por % */}
        <AjusteRapidoPercentual precos={precos} setPrecos={setPrecos} />

        {/* Preços por modelo + multiplicador individual */}
        <div>
          <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">Preço base e multiplicador por modelo</p>
          <div className="border border-slate-200 rounded-xl overflow-hidden">
            {Object.entries(CATEGORIAS_MODELO).map(([cat, modelos]) => (
              <div key={cat} className="border-b border-slate-100 last:border-0">
                <button type="button"
                  onClick={() => setCatPre(catPrecoAberta === cat ? null : cat)}
                  className="w-full flex items-center justify-between px-4 py-2.5 bg-slate-50 hover:bg-[#FFFDE7] text-sm font-semibold text-slate-700 transition-colors"
                >
                  {cat}
                  <ChevronDown size={13} className={`text-slate-400 transition-transform ${catPrecoAberta === cat ? 'rotate-180' : ''}`} />
                </button>
                {catPrecoAberta === cat && (
                  <div className="divide-y divide-slate-50">
                    <div className="flex items-center gap-3 px-4 py-1.5 bg-slate-50/60">
                      <span className="text-[10px] font-semibold text-slate-400 flex-1 uppercase tracking-wide">Modelo</span>
                      <span className="text-[10px] font-semibold text-slate-400 w-28 shrink-0 text-right uppercase tracking-wide">Preço base</span>
                      <span className="text-[10px] font-semibold text-slate-400 w-20 shrink-0 text-right uppercase tracking-wide">Multiplicador</span>
                    </div>
                    {modelos.map(m => (
                      <div key={m} className="flex items-center gap-3 px-4 py-2 bg-white">
                        <span className="text-sm text-slate-700 flex-1">{m}</span>
                        <div className="relative w-28 shrink-0">
                          <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-xs text-slate-400">R$</span>
                          <input
                            type="number" min="0" step="1"
                            value={precos.modelos[m] || ''}
                            onChange={e => setPrecoModelo(m, e.target.value)}
                            placeholder="0"
                            className="input pl-8 py-1.5 text-sm text-right"
                          />
                        </div>
                        <div className="relative w-20 shrink-0">
                          <input
                            type="number" min="1" max="10" step="0.1"
                            value={precos.multiplicadores?.[m] || ''}
                            onChange={e => setMultiModelo(m, e.target.value)}
                            placeholder={String(precos.multiplicadorDefault ?? 3.5)}
                            className="input py-1.5 text-sm text-right"
                          />
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </div>
          <p className="text-[10px] text-slate-400 mt-1.5">Multiplicador vazio = usa o padrão acima.</p>
        </div>

        {/* Preços de puxadores */}
        <div>
          <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">Puxadores (por unidade)</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {PUXADOR_TIPOS.map(tipo => (
              <div key={tipo}>
                <label className="text-xs text-slate-500 mb-1 block">{tipo}</label>
                <div className="relative">
                  <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-xs text-slate-400">R$</span>
                  <input type="number" min="0" step="1"
                    value={precos.puxadores[tipo] || ''}
                    onChange={e => setPrecoPuxador(tipo, e.target.value)}
                    placeholder="0"
                    className="input pl-8 text-sm text-right"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Adicionais booleanos */}
        <div>
          <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">Adicionais (preço fixo)</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {ADICIONAIS_BOOLEAN.map(({ key, label }) => (
              <div key={key}>
                <label className="text-xs text-slate-500 mb-1 block">{label}</label>
                <div className="relative">
                  <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-xs text-slate-400">R$</span>
                  <input type="number" min="0" step="1"
                    value={precos.adicionais[key] || ''}
                    onChange={e => setPrecoAdicional(key, e.target.value)}
                    placeholder="0"
                    className="input pl-8 text-sm text-right"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Adicionais por unidade */}
        <div>
          <p className="text-xs font-semibold text-slate-500 uppercase tracking-wide mb-2">Adicionais por unidade</p>
          <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
            {ADICIONAIS_QUANTIDADE.map(({ key, label }) => (
              <div key={key}>
                <label className="text-xs text-slate-500 mb-1 block">{label}</label>
                <div className="relative">
                  <span className="absolute left-2.5 top-1/2 -translate-y-1/2 text-xs text-slate-400">R$</span>
                  <input type="number" min="0" step="1"
                    value={precos.adicionais[key] || ''}
                    onChange={e => setPrecoAdicional(key, e.target.value)}
                    placeholder="0"
                    className="input pl-8 text-sm text-right"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        <button
          onClick={handleSalvarPrecos}
          className={`btn-primary text-sm ${salvoPrecos ? '!bg-green-500 hover:!bg-green-600' : ''}`}
        >
          {salvoPrecos ? <Check size={14} /> : <Save size={14} />}
          {salvoPrecos ? 'Tabela salva!' : 'Salvar tabela de preços'}
        </button>
      </div>

      {/* Acesso */}
      <div className="card p-6 space-y-4 mb-5">
        <h3 className="text-sm font-bold text-[#111111] uppercase tracking-wide flex items-center gap-2">
          <KeyRound size={15} className="text-[#CC8800]" />
          Minha conta
        </h3>

        <div className="flex items-center gap-3 px-3 py-2.5 rounded-lg bg-slate-50 border border-slate-100">
          <span className="text-sm font-semibold text-slate-800">{profile?.nome || profile?.username}</span>
          <span className="text-xs font-mono text-slate-400 ml-auto">{profile?.username}</span>
          <span className="text-[10px] bg-[#F5C200]/20 text-[#CC8800] px-2 py-0.5 rounded-full font-semibold">você</span>
        </div>

        {/* Alterar senha */}
        <div className="border-t border-slate-100 pt-4">
          <p className="text-xs font-semibold text-slate-400 uppercase tracking-wide mb-3">Alterar minha senha</p>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="label">Nova senha</label>
              <input type={mostrarSenhas ? 'text' : 'password'} value={senhaNova}
                onChange={e => { setSenhaNova(e.target.value); setErroSenha('') }}
                className="input" placeholder="mín. 6 caracteres" />
            </div>
            <div>
              <label className="label">Confirmar</label>
              <input type={mostrarSenhas ? 'text' : 'password'} value={senhaConf}
                onChange={e => { setSenhaConf(e.target.value); setErroSenha('') }}
                className="input" placeholder="••••••••" />
            </div>
          </div>
          <label className="flex items-center gap-2 text-xs text-slate-500 cursor-pointer mt-2">
            <input type="checkbox" checked={mostrarSenhas} onChange={e => setMostrarSenhas(e.target.checked)}
              className="accent-[#F5C200]" />
            Mostrar senhas
          </label>
          {erroSenha && <p className="text-xs text-red-500 mt-2">{erroSenha}</p>}
          {okSenha   && <p className="text-xs text-green-600 mt-2 flex items-center gap-1"><Check size={11} />{okSenha}</p>}
          <button onClick={handleTrocarSenha} disabled={loadingSenha} className="btn-secondary text-sm mt-3">
            <KeyRound size={14} /> {loadingSenha ? 'Salvando...' : 'Alterar senha'}
          </button>
        </div>
      </div>

      {/* Bling ERP */}
      <div className="card p-6 space-y-4 mb-6">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 rounded-md bg-[#E8F4FF] flex items-center justify-center shrink-0">
              <span className="text-[#0057B8] text-xs font-black">B</span>
            </div>
            <h3 className="text-sm font-bold text-[#111111]">Bling ERP</h3>
          </div>
          {blingTokens ? (
            <span className="flex items-center gap-1.5 text-xs font-semibold text-green-600 bg-green-50 border border-green-200 rounded-full px-2.5 py-1">
              <span className="w-1.5 h-1.5 rounded-full bg-green-500 shrink-0" />
              Conectado
            </span>
          ) : (
            <span className="flex items-center gap-1.5 text-xs font-semibold text-slate-400 bg-slate-100 rounded-full px-2.5 py-1">
              <span className="w-1.5 h-1.5 rounded-full bg-slate-300 shrink-0" />
              Desconectado
            </span>
          )}
        </div>

        <p className="text-xs text-slate-500">
          Ao salvar um pedido, ele é criado automaticamente como <strong>pedido de venda</strong> no Bling via OAuth2.
          O token é renovado automaticamente a cada 6 horas.
        </p>

        {/* Credenciais */}
        <div className="grid grid-cols-1 gap-3">
          <div>
            <label className="label">Client ID</label>
            <input
              value={config.blingClientId || ''}
              onChange={e => set('blingClientId', e.target.value)}
              className="input font-mono text-xs"
              placeholder="Cole aqui o Client ID do seu app Bling"
            />
          </div>
          <div>
            <label className="label">Client Secret</label>
            <input
              type="password"
              value={config.blingClientSecret || ''}
              onChange={e => set('blingClientSecret', e.target.value)}
              className="input font-mono text-xs"
              placeholder="Cole aqui o Client Secret do seu app Bling"
            />
          </div>
        </div>

        {/* Instruções */}
        <div className="bg-slate-50 rounded-xl p-4 space-y-2 text-xs text-slate-600">
          <p className="font-bold uppercase tracking-wide text-slate-400 text-[10px]">Como configurar</p>
          <ol className="space-y-1.5 list-none">
            <li className="flex gap-2">
              <span className="w-4 h-4 rounded-full bg-[#111111] text-[#F5C200] text-[9px] font-bold flex items-center justify-center shrink-0">1</span>
              Acesse <strong>developer.bling.com.br</strong> e crie um aplicativo
            </li>
            <li className="flex gap-2">
              <span className="w-4 h-4 rounded-full bg-[#111111] text-[#F5C200] text-[9px] font-bold flex items-center justify-center shrink-0">2</span>
              URL de redirecionamento: <code className="bg-slate-200 px-1 rounded">{typeof window !== 'undefined' ? window.location.origin : 'http://localhost:5173'}/bling/callback</code>
            </li>
            <li className="flex gap-2">
              <span className="w-4 h-4 rounded-full bg-[#111111] text-[#F5C200] text-[9px] font-bold flex items-center justify-center shrink-0">3</span>
              Cole o <strong>Client ID</strong> e <strong>Client Secret</strong> acima, salve e clique em <strong>Conectar ao Bling</strong>
            </li>
          </ol>
        </div>

        {/* Ações */}
        <div className="flex items-center gap-3 flex-wrap">
          {!blingTokens ? (
            <button
              onClick={() => {
                handleSalvar()
                const id  = config.blingClientId?.trim()
                if (!id) { alert('Preencha o Client ID antes de conectar.'); return }
                window.location.href = getBlingAuthUrl(id)
              }}
              className="btn-primary text-sm"
              disabled={!config.blingClientId?.trim() || !config.blingClientSecret?.trim()}
            >
              <Link2 size={14} />
              Conectar ao Bling
            </button>
          ) : (
            <>
              <button
                onClick={() => {
                  handleSalvar()
                  const id = config.blingClientId?.trim()
                  if (!id) { alert('Preencha o Client ID antes de reconectar.'); return }
                  window.location.href = getBlingAuthUrl(id)
                }}
                className="btn-secondary text-sm"
              >
                <RefreshCw size={14} />
                Reconectar
              </button>
              <button
                onClick={() => {
                  if (!confirm('Desconectar o Bling? Os pedidos não serão mais enviados automaticamente.')) return
                  clearBlingTokens()
                  setBlingTokens(null)
                }}
                className="btn-secondary text-sm text-red-500 hover:!border-red-200 hover:!bg-red-50"
              >
                <Link2Off size={14} />
                Desconectar
              </button>
              {blingTokens?.expires_at && (
                <span className="text-xs text-slate-400 ml-auto">
                  Token válido até {new Date(blingTokens.expires_at).toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' })}
                </span>
              )}
            </>
          )}
        </div>
      </div>

      {/* Sincronização com nuvem */}
      <div className="card p-6 space-y-3 mb-5">
        <h3 className="text-sm font-bold text-[#111111] uppercase tracking-wide flex items-center gap-2">
          <Upload size={15} className="text-[#CC8800]" />
          Sincronização com a nuvem
        </h3>
        <p className="text-xs text-slate-500">
          Use este botão para enviar todos os dados deste dispositivo para a nuvem.
          Faça isso uma vez no computador que já tem os dados para disponibilizá-los para toda a equipe.
        </p>
        <button
          onClick={handlePushToCloud}
          disabled={syncStatus === 'loading'}
          className={`btn-secondary text-sm ${syncStatus.startsWith('ok') ? '!border-green-300 !text-green-600 !bg-green-50' : ''} ${syncStatus === 'error' ? '!border-red-300 !text-red-500 !bg-red-50' : ''}`}
        >
          {syncStatus === 'loading' && <div className="w-3.5 h-3.5 border-2 border-current border-t-transparent rounded-full animate-spin" />}
          {syncStatus.startsWith('ok') && <Check size={14} />}
          {!syncStatus || syncStatus === 'error' ? <Upload size={14} /> : null}
          {syncStatus === 'loading' ? 'Enviando…' :
           syncStatus.startsWith('ok') ? `${syncStatus.split(':')[1]} chaves enviadas para a nuvem!` :
           syncStatus === 'error' ? 'Erro ao sincronizar' :
           'Enviar dados deste dispositivo para a nuvem'}
        </button>
      </div>

      <button
        onClick={handleSalvar}
        className={`btn-primary w-full justify-center ${salvo ? '!bg-green-500 hover:!bg-green-600' : ''}`}
      >
        {salvo ? <Check size={16} /> : <Save size={16} />}
        {salvo ? 'Salvo com sucesso!' : 'Salvar configurações'}
      </button>
    </div>
  )
}

// ── Ajuste rápido de multiplicador por percentual ────────────────────────────
// Ferramenta pra quando você/designer avaliam preço final por modelo e
// querem "subir X%" ou "baixar Y%" sem calcular a mão. Lê o multiplicador
// atual em uso (individual ou default), aplica o ajuste percentual e mostra
// o valor calculado. Ao aplicar, seta o multiplicador individual no state.
// Persiste no clique de "Salvar" da seção principal.
function AjusteRapidoPercentual({ precos, setPrecos }) {
  const [modelo, setModelo]     = useState('')
  const [ajustePct, setAjuste]  = useState('')
  const [aplicado, setAplicado] = useState(null)

  const multiAtual = modelo
    ? (Number(precos.multiplicadores?.[modelo]) || Number(precos.multiplicadorDefault) || 3.5)
    : 0
  const origem = modelo && precos.multiplicadores?.[modelo]
    ? 'individual'
    : (modelo ? 'default' : '')
  const pctNum = Number(String(ajustePct).replace(',', '.'))
  const pctValido = !Number.isNaN(pctNum) && ajustePct !== '' && ajustePct !== '-'
  const multiNovo = pctValido && modelo
    ? Math.round(multiAtual * (1 + pctNum / 100) * 1000) / 1000
    : 0

  // IMPORTANTE: SALVA DIRETO no localStorage + Supabase, não deixa em state.
  // Antes o Aplicar só chamava setMulti (state) e dependia do usuário
  // clicar em "Salvar preços" pra persistir — se esquecesse, o valor
  // sumia ao próximo sync. Agora o clique único faz tudo.
  function aplicar() {
    if (!modelo || !pctValido) return
    const novosPrecos = {
      ...precos,
      multiplicadores: { ...precos.multiplicadores, [modelo]: multiNovo },
    }
    setPrecos(novosPrecos)
    savePrecos(novosPrecos)  // salva localStorage + syncKey pro Supabase
    setAplicado({ modelo, antes: multiAtual, depois: multiNovo, pct: pctNum })
    setAjuste('')
    setTimeout(() => setAplicado(null), 6000)
  }

  return (
    <div className="border-2 border-[#F5C200]/30 bg-amber-50/30 rounded-xl p-4 space-y-3">
      <div>
        <p className="text-xs font-semibold text-slate-700 uppercase tracking-wide">
          Ajuste rápido por %
        </p>
        <p className="text-xs text-slate-500 mt-0.5 leading-relaxed">
          Ex: Buffet com multiplicador 3× e você quer subir 20% no preço final →
          escolhe Buffet + digita <code className="bg-white/70 px-1 rounded">20</code> → aplica → vira 3,6×.
          O clique em <strong>Aplicar</strong> já salva direto no Supabase (não precisa clicar em Salvar preços depois).
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-[1fr_120px_auto] gap-2">
        {/* Modelo */}
        <select
          value={modelo}
          onChange={e => { setModelo(e.target.value); setAjuste('') }}
          className="input text-sm"
        >
          <option value="">— Selecione o modelo —</option>
          {Object.entries(CATEGORIAS_MODELO).map(([cat, modelos]) => (
            <optgroup key={cat} label={cat}>
              {modelos.map(m => (
                <option key={m} value={m}>{m}</option>
              ))}
            </optgroup>
          ))}
        </select>

        {/* Ajuste % */}
        <div className="relative">
          <input
            type="text"
            inputMode="decimal"
            value={ajustePct}
            onChange={e => setAjuste(e.target.value.replace(/[^\d,.\-]/g, ''))}
            placeholder="+20 / -12"
            disabled={!modelo}
            className="input text-sm text-center pr-6 disabled:bg-slate-100 disabled:text-slate-400"
          />
          <span className="absolute right-2 top-1/2 -translate-y-1/2 text-sm text-slate-400 pointer-events-none">%</span>
        </div>

        {/* Botão */}
        <button
          type="button"
          onClick={aplicar}
          disabled={!modelo || !pctValido}
          className="btn-primary text-sm disabled:opacity-40 disabled:cursor-not-allowed"
        >
          Aplicar
        </button>
      </div>

      {/* Preview em tempo real */}
      {modelo && (
        <div className="text-xs text-slate-600 bg-white/60 rounded-lg px-3 py-2 grid grid-cols-3 gap-2">
          <div>
            <p className="text-[10px] uppercase text-slate-400 font-semibold">Atual ({origem})</p>
            <p className="font-mono font-bold text-slate-700">{multiAtual.toFixed(3)}×</p>
          </div>
          <div>
            <p className="text-[10px] uppercase text-slate-400 font-semibold">Ajuste</p>
            <p className="font-mono font-bold text-slate-700">
              {pctValido ? `${pctNum > 0 ? '+' : ''}${pctNum}%` : '—'}
            </p>
          </div>
          <div>
            <p className="text-[10px] uppercase text-slate-400 font-semibold">Novo</p>
            <p className={`font-mono font-black text-lg leading-none mt-0.5 ${
              pctValido ? 'text-[#CC8800]' : 'text-slate-300'
            }`}>
              {pctValido ? `${multiNovo.toFixed(3)}×` : '—'}
            </p>
          </div>
        </div>
      )}

      {/* Confirmação após aplicar */}
      {aplicado && (
        <div className="text-xs bg-green-100 border border-green-300 rounded-lg px-3 py-2 text-green-800">
          ✓ <strong>{aplicado.modelo}</strong> ajustado: {aplicado.antes.toFixed(3)}× → <strong>{aplicado.depois.toFixed(3)}×</strong>
          {' '}({aplicado.pct > 0 ? '+' : ''}{aplicado.pct}%).
          {' '}<strong>Salvo no Supabase</strong> — todos os dispositivos vão atualizar no próximo sync.
        </div>
      )}
    </div>
  )
}


// ── Banner de erro de escrita no Supabase ────────────────────────────────────
// Poll leve pra detectar quando o syncKey grava mini_last_write_error.
// Vale ouro pra debugar "salvei mas não persistiu": se aparecer aqui, o
// upsert foi rejeitado (RLS, rede, permissão etc.) e precisamos investigar
// o Supabase — não é bug de UI.
function ErroEscritaBanner() {
  const [erro, setErro] = useState(() => {
    try { return JSON.parse(localStorage.getItem("mini_last_write_error") || "null") } catch { return null }
  })
  useEffect(() => {
    const t = setInterval(() => {
      try {
        const atual = JSON.parse(localStorage.getItem("mini_last_write_error") || "null")
        setErro(atual)
      } catch { /* ignora */ }
    }, 2000)
    return () => clearInterval(t)
  }, [])
  if (!erro) return null
  return (
    <div className="mb-5 rounded-xl border-2 border-red-300 bg-red-50 p-4 flex items-start gap-3">
      <div className="w-8 h-8 rounded-full bg-red-200 flex items-center justify-center shrink-0">
        <span className="text-red-700 font-bold text-lg">!</span>
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm font-bold text-red-800">
          Erro ao salvar no Supabase — o valor NÃO foi persistido
        </p>
        <p className="text-xs text-red-700 mt-1 leading-relaxed">
          O valor foi salvo só neste dispositivo. Ao reabrir o app ou trocar de dispositivo,
          o valor pode voltar ao anterior. Motivo técnico:
        </p>
        <p className="text-xs font-mono bg-red-100 p-2 rounded mt-2 text-red-900 break-all">
          {erro.op} · {erro.key} · {erro.msg}
        </p>
        <p className="text-[10px] text-red-600 mt-1.5">
          Provável causa: RLS (Row-Level Security) do Supabase bloqueando escrita pra este usuário.
          Manda essa mensagem pro suporte técnico.
        </p>
        <button
          onClick={() => { localStorage.removeItem("mini_last_write_error"); setErro(null) }}
          className="text-xs font-semibold text-red-700 underline mt-2 hover:text-red-900"
        >
          Dispensar aviso
        </button>
      </div>
    </div>
  )
}

